export class AccordionUtil {
  el: HTMLDetailsElement;

  summary: any;

  content: any;

  animation: Animation | null;

  isClosing: boolean;

  isExpanding: boolean;

  onStateChange?: (state: 'open' | 'closed') => void;

  clickHandler: (e: MouseEvent) => void;

  // https://css-tricks.com/how-to-animate-the-details-element-using-waapi/
  // Mostly copied from here. Only additions were for a 'destroy' clean up method
  // and toggling an 'isclosing' attr to prevent transition delay in scss.

  constructor(
    el: HTMLDetailsElement,
    onStateChange?: (state: 'open' | 'closed') => void
  ) {
    this.el = el;
    this.summary = el.querySelector('summary');
    this.content = el.querySelector('summary + div');

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.clickHandler = (e: MouseEvent) => this.onClick(e);
    this.summary?.addEventListener('click', this.clickHandler);
    this.onStateChange = onStateChange;
  }

  destroy(): void {
    this.summary?.removeEventListener('click', this.clickHandler);
  }

  onClick(e: MouseEvent): void {
    e.preventDefault();
    this.el.style.overflow = 'hidden';

    if (this.isClosing || !this.el.open) {
      this.open();
      if (this.onStateChange) {
        this.onStateChange('open');
      }
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
      if (this.onStateChange) {
        this.onStateChange('closed');
      }
    }
  }

  shrink(): void {
    this.isClosing = true;

    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: 'ease-out',
      }
    );
    // isclosing attr is used in scss for icon animation
    this.el.setAttribute('isclosing', 'true');

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => {
      this.isClosing = false;
    };
  }

  open(): void {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand(): void {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${
      this.summary.offsetHeight + this.content.offsetHeight
    }px`;

    if (this.animation) {
      this.animation.cancel();
    }

    this.animation = this.el.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 400,
        easing: 'ease-out',
      }
    );
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => {
      this.isExpanding = false;
    };
  }

  onAnimationFinish(open: boolean): void {
    this.el.open = open;

    this.el.removeAttribute('isClosing');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = '';
    this.el.style.overflow = '';
  }
}
